import { gql } from '@apollo/client';
const GET_SPECIFICATION_HEADER = gql `
  query GetSpecificationHeader($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        fancyName
        itemCode
        state
        estimatedCostCalculationBlocked
        confirmationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
        estimatedCostCalculationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
        variants {
          edges {
            node {
              id
            }
          }
        }
        projections {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_HEADER;
